import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import {
  Box,
  IconButton,
  List,
  Typography,
  useMediaQuery,
  type Theme,
} from '@mui/material';
import { HelpButton } from '@pn/ui/custom-components/HelpButton';
import { useUI } from 'src/ui/contexts/useUIState';
import { PageComponent } from 'src/ui/navigation/NavDrawerPageComponent';
import { pages } from 'src/ui/pages';

export function NavDrawerContent() {
  const { isSidePanelExpanded, handleToggleSidePanel } = useUI();

  const isLargeScreen = useMediaQuery(
    (theme: Theme) => theme.breakpoints.up('lg'),
    { noSsr: true }
  );

  const isCollapsed = isLargeScreen && !isSidePanelExpanded;

  return (
    <Box
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: isCollapsed ? 56 : 260,
          height: '100%',
        },
        (theme) => ({
          backgroundColor: theme.palette.background.paper,
        }),
      ]}
    >
      <Box
        sx={{
          p: 1.5,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: isCollapsed ? 'center' : 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant={'h6'}
            sx={{
              fontWeight: 'bold',
              px: 1,
              display: !isCollapsed ? 'block' : 'none',
            }}
          >
            Dashboards
          </Typography>
          <IconButton
            size={'small'}
            onClick={handleToggleSidePanel}
            sx={(theme) => ({
              [theme.breakpoints.down('lg')]: {
                display: 'none',
              },
              mr: !isCollapsed ? 1.5 : 0,
            })}
          >
            {!isCollapsed ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </Box>
        <List sx={{ width: '100%' }} component="nav" dense>
          {pages.map((page) => (
            <PageComponent key={page.title} dense={isCollapsed} page={page} />
          ))}
        </List>
      </Box>
      <Box sx={{ p: isCollapsed ? 1 : 1.5 }}>
        <HelpButton appName="intel" collapsed={isCollapsed} />
      </Box>
    </Box>
  );
}
